import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import * as moment from 'moment';

@Injectable() export class UtilityService {

  private merchantPassword = new BehaviorSubject<any>(null);

  constructor() { }

  get getYear(): string {
    return moment().year().toString();
  }

  setMerchantPassword(pw: any) {
    this.merchantPassword.next(pw);
  }

  getMerchantPassword(): Observable<string> {
    return this.merchantPassword.asObservable();
  }
}
